export default __webpack_public_path__ + "static/japanese-2-11679db436433f4b11ce3cf66c297e07.jpg";